var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoreditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2001 13.494C15.2001 13.494 11.6001 17.394 11.6001 19.794C11.5935 20.2733 11.6814 20.7493 11.8588 21.1946C12.0362 21.64 12.2995 22.046 12.6338 22.3896C13.3089 23.0835 14.2321 23.4807 15.2001 23.494C16.1681 23.5073 17.1018 23.1354 17.7957 22.4603C18.1393 22.126 18.4136 21.7273 18.6031 21.287C18.7926 20.8467 18.8935 20.3733 18.9001 19.894V19.794C18.9001 17.394 15.2001 13.494 15.2001 13.494ZM13.7301 12.137L14.3991 11.413L12.1001 5H10.1001L5.1001 19H7.1001L8.5301 15H11.4731C12.1518 13.9909 12.9049 13.0339 13.7261 12.137H13.7301ZM11.1001 7.8L12.9601 13H9.2441L11.1001 7.8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoreditor);
export default __webpack_public_path__ + "static/media/coloreditor.b2c7867fa1032025fd5ed5b0cef4b288.svg";
export { ForwardRef as ReactComponent };